export const SET_SAVES = "SET_SAVES";
export const SET_CURRENT_SAVE = "SET_CURRENT_SAVE";
export const SET_RECENT_TRANSACTIONS = "SET_RECENT_TRANSACTIONS";
export const SET_REPORT_DATA = "SET_REPORT_DATA";
